(() => {
  const popup = document.querySelector('[data-grind-sms-popup]');
  if (!popup) return;

  const storageKey = 'grind-sms-popup-seen';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const forcePreview = new URLSearchParams(window.location.search).has('preview_sms');
  let opened = false;

  const recentlySeen = () => {
    if (forcePreview) return false;
    try { return Date.now() - Number(localStorage.getItem(storageKey) || 0) < sevenDays; }
    catch (_) { return false; }
  };

  const open = (force = false) => {
    const cookieBanner = document.querySelector('[data-grind-cookie-banner]');
    if (!force && cookieBanner && !cookieBanner.hidden) return;
    if (!popup.hidden || (!force && (opened || recentlySeen()))) return;
    opened = true;
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add('is-open'));
    document.body.classList.add('g-sms-pop-lock');
    popup.querySelector('input, button')?.focus();
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
  };

  const close = () => {
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.body.classList.remove('g-sms-pop-lock');
  };

  popup.querySelectorAll('[data-grind-sms-close]').forEach((button) => button.addEventListener('click', close));
  document.querySelectorAll('a[href="#grind-sms-signup"], [data-grind-sms-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      open(true);
    });
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });

  if (popup.querySelector('[data-grind-sms-success]')) {
    popup.hidden = false;
    popup.classList.add('is-open');
    document.body.classList.add('g-sms-pop-lock');
    popup.querySelector('[data-grind-sms-success]')?.focus();
  } else if (forcePreview) {
    open();
  } else if (!recentlySeen()) {
    document.addEventListener('mouseout', (event) => {
      if (event.clientY <= 4 && !event.relatedTarget) open();
    }, { once: true });
    window.setTimeout(open, 14000);
  }

  popup.querySelector('[data-copy-code]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(button.dataset.copyCode);
      button.textContent = 'Copied!';
    } catch (_) {
      button.textContent = button.dataset.copyCode;
    }
  });
})();
